import { BaseWizardProps } from '../wizard/wizard-step-base';
import { useEffect, useState } from 'react';
import { WizardButtonGroup } from '../wizard/wizard-button-group-component';
import { GoACallout, GoASpacer } from '@abgov/react-components';
import { useNavigate } from 'react-router-dom';
import styles from './eligibility.module.css';
export interface EligibilitySuccessProps extends BaseWizardProps {
  keycloakCallbackPath: string;
}

export const EligibilitySuccessComponent = ({
  navigationConfiguration,
}: EligibilitySuccessProps) => {
  const navigate = useNavigate();

  const [nextPage, setNextPage] = useState('');

  useEffect(() => {
    const pageConfig = navigationConfiguration.pagingConfiguration.find(
      (item) => item.default !== undefined,
    );

    setNextPage(pageConfig?.default ?? 'error');
  }, []);

  const navigateToDashboard = () => {
    navigate('/dashboard');
  };

  return (
    <div>
      <GoACallout type="success">
        Success, you meet the eligibility requirements to continue using Report
        My Collision online service.
      </GoACallout>
      <h2>Before you start</h2>
      <GoASpacer vSpacing={'m'} />
      <div className="large-body">
        Have the following documents on hand before starting your collision
        report
      </div>
      <ul className="goa-unordered-list">
        <li>Your Alberta Driver's Licence</li>
        <li>Your Alberta vehicle registration certificate</li>
        <li>Your vehicle insurance certificate (pink card)</li>
      </ul>
      <h3>Damage sticker</h3>
      <GoASpacer vSpacing={'m'} />
      As of January 1, 2024, the threshold for reporting collision damage has
      increased to $5,000. This means that if the combined damage to the vehicle
      and property involved in a collision is $5,000 or more, you must report
      the collision. In Alberta, for collisions that meet the damage threshold,
      repairs to a vehicle cannot be started until a damage sticker is obtained.
      You can get a damage sticker through the Report My Collision online
      service after your collision report is reviewed and approved by law
      enforcement.
      <GoASpacer vSpacing={'l'} />
      <GoACallout heading="Submitting your collision report" type="information">
        <ul>
          <li>
            You can get started with your report by logging in with a basic
            Alberta.ca account.
          </li>
          <li>
            In order to submit your completed collision report, you must have a
            verified Alberta.ca account.
          </li>
          <li>
            After logging in, you can start or resume a collision report on your
            dashboard, where you will also receive important updates and
            documents after law enforcement review.
          </li>
        </ul>
      </GoACallout>
      <div style={{ marginTop: '-35px' }}>
        <WizardButtonGroup
          showViewSummaryButton={false}
          goToReview={navigationConfiguration.goToReview}
          nextPage={nextPage}
          navigate={navigateToDashboard}
          buttonText="Get Started"
          buttonTrailingIcon="arrow-forward"
        />
      </div>
    </div>
  );
};
